import { Row, Col, Card, Space } from 'antd';
import { MailOutlined, PhoneOutlined } from '@ant-design/icons';
import MainLayout from '@/components/Layout/MainLayout';
import useGlobalConfig from '@/store/global';
import { programConfig } from '@/config';

const HomePage = () => {
  const { program } = useGlobalConfig()
  const programInfo = programConfig.find(item => item.Program === program.name)

  return (
    <MainLayout>
      <div className="mb-6">
        <h2 className="text-2xl md:text-3xl font-bold mb-4">Contact Us</h2>

        <Row gutter={[32, 32]} justify="center">
          <Col xs={24} md={12}>
            <Card>
              <h3 className="text-lg md:text-xl font-bold md:mb-4">{programInfo?.HubRole}</h3>
              <Space direction="vertical" className='mt-4'>
                <div className="flex items-center space-x-2">
                  <div className='flex items-center space-x-2'>
                    <MailOutlined /> <span>Email:</span>
                  </div>
                  <a className='text-blue-500 hover:text-blue-600 hover:underline' href={`mailto:${programInfo?.HubEmail}`}>{programInfo?.HubEmail}</a>
                </div>
                <div className="flex items-center space-x-2">
                  <div className='flex items-center space-x-2'>
                    <PhoneOutlined /> <span>Phone:</span>
                  </div>
                  <a className='text-blue-500 hover:text-blue-600 hover:underline' href={`tel:${programInfo?.HubPhone}`}>{programInfo?.HubPhone}</a>
                </div>
              </Space>
            </Card>
          </Col>

          <Col xs={24} md={12}>
            <Card>
              <h3 className="text-lg md:text-xl font-bold md:mb-4">Billing and Technical Support</h3>
              <Space direction="vertical" className='mt-4'>
                <div className="flex items-center space-x-2">
                  <div className='flex items-center space-x-2'>
                    <MailOutlined /> <span>Email:</span>
                  </div>
                  <a className='text-blue-500 hover:text-blue-600 hover:underline' href={`mailto:${programInfo?.BillingSupportEmail}`}>{programInfo?.BillingSupportEmail}</a>
                </div>
                <div className="flex items-center space-x-2">
                  <div className='flex items-center space-x-2'>
                    <PhoneOutlined /> <span>Phone:</span>
                  </div>
                  <a className='text-blue-500 hover:text-blue-600 hover:underline' href={`tel:${programInfo?.BillingSupportPhone}`}>{programInfo?.BillingSupportPhone}</a>
                </div>
              </Space>
            </Card>
          </Col>
        </Row>
      </div>
    </MainLayout>
  );
};

export default HomePage;
